"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _operators = require("rxjs/operators");

var _utils = require("@alycecom/utils");

var _services = require("@alycecom/services");

var _recipient = require("./recipient.actions");

var addRecipientEpic = function addRecipientEpic(action$, state$, _ref) {
  var apiService = _ref.apiService,
      showGlobalMessage = _ref.messagesService.showGlobalMessage;
  return action$.pipe((0, _utils.ofType)(_recipient.addRecipient), (0, _operators.switchMap)(function (_ref2) {
    var _ref2$payload = _ref2.payload,
        campaignId = _ref2$payload.campaignId,
        body = (0, _objectWithoutProperties2.default)(_ref2$payload, ["campaignId"]);
    return apiService.post("/api/v1/campaigns/activate/campaigns/".concat(campaignId, "/contacts"), {
      body
    }, true).pipe((0, _operators.mergeMap)(function (_ref3) {
      var data = _ref3.data;
      return [(0, _recipient.addRecipientSuccess)({
        email: data.email
      }), showGlobalMessage({
        type: _services.MessageType.Success,
        text: 'A new recipient has been added'
      }), _services.TrackEvent.actions.trackEvent({
        name: 'Contact - Added',
        payload: {
          app: 'Gifting on the fly',
          campaignId,
          contactId: data.id,
          feature: 'GOTF add'
        }
      })];
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(_recipient.addRecipientFail))));
  }));
};

var _default = [addRecipientEpic];
exports.default = _default;